<template>
  <el-button :loading="loading" size="mini" type="primary" @click="addShow()" style="margin-right:10px">同步盘组信息</el-button>
  <el-dialog
    v-model="dialogFormVisible"
    title="更新公司"
    width="60%"
    :before-close="handleClose"
  >
    <div>
      <el-select v-model="macValue" placeholder="请选择mac地址" @change="changeValue" size="mini" style="margin-right:10px">
        <el-option v-for="item in options" :key="item.mac" :label="item.name+'-'+item.mac" :value="item.name"></el-option>
      </el-select>
      <div style="float:right">
      <el-button size="mini" type="primary" @click="saveUser()" style="margin-right:10px" plain>一键填写用户名</el-button>
      </div>
      <!-- <el-button size="mini" type="primary" @click="savePass()" style="margin-right:10px" plain>一键填写密码</el-button> -->
      <el-table size="mini" :data="tableData" v-loading = "isLoading" border style="width: 100%;margin-top:10px" :header-cell-style="{background:'#66b1ff',color:'#ffff'}">
        <el-table-column fixed type="index" width="50" label="序号" align="center" :index="computeTableIndex"></el-table-column>
        <el-table-column prop="name" label="公司名称" align="center"/>
        <el-table-column prop="tax_no" label="纳税人识别号" align="center"/>
        <el-table-column prop="type" label="公司类型" align="center"/>

        <el-table-column label="用户名" width="160" align="center">
          <template v-slot="scope">
            <el-input size="mini" v-model="scope.row.userName" placeholder="请输入用户名"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="saveCompany()">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>

import { addCompany, contrastCompanyZy ,zyDeviceList } from "@/api/ea";
export default {
  props: {
    
  },
  data () {
    return {
      loading: false,
      tableData: [],
      formLabelWidth: "110px",
      dialogFormVisible: false,
      options:[],
      macValue:'',
      isLoading:false
    }
  },
  created () {
    
  },
  methods: {
    // savePass(){
    //   this.$prompt('请输入密码', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   }).then(({ value }) => {
    //     this.tableData.map(v=>{
    //       v.password = value
    //     })
    //   })
    // },
    saveUser(){
      this.$prompt('请输入用户名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.tableData.map(v=>{
          v.userName = value
        })
      })
    },
    getList(val){
      this.isLoading = true;
      contrastCompanyZy({name:val}).then(res=>{
        this.loading = false
        this.isLoading = false;
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }else{
          this.tableData = []
        }
      })
    },
    addShow(){
      zyDeviceList().then(res=>{
        this.options = res.data.data.list
      })
      this.loading = false
      this.dialogFormVisible = true
      // this.getList()
    },
    saveCompany(){
      let status = false
      let params = []
      this.tableData.map(v=>{
        if(v.password == ""){
          status = true
        }
        params.push({
          name: v.name,
          tax_no: v.tax_no,
          type: v.type == "小规模纳税人"?1:2,
          userName: v.userName,
          password: v.password,
        })
      })
      if(status){
        this.$qzfMessage("请填写密码",2)
        return
      }
      addCompany(params).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("添加成功")
          this.dialogFormVisible = false
          this.$emit("success")
        }
      })
    },
    changeValue(val){
      console.log(val);
      this.getList(val)
    },
  }
}
</script>
<style lang="scss" scoped>
.input{
  width: 200px;
}
</style>